import { httpGet } from './api/axios_api';
import Constants from '../constants/constants';

export async function getAllMultiplayerGames() {
  const url = `${Constants.BACKEND_URL}/get-all-multiplayer-games`;
  return httpGet(url, {});
}
